import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './application-user.reducer';

export const ApplicationUserDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const applicationUserEntity = useAppSelector(state => state.applicationUser.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="applicationUserDetailsHeading">
          <Translate contentKey="rainspotApp.applicationUser.detail.title">ApplicationUser</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{applicationUserEntity.id}</dd>
          <dt>
            <span id="additionalField">
              <Translate contentKey="rainspotApp.applicationUser.additionalField">Additional Field</Translate>
            </span>
          </dt>
          <dd>{applicationUserEntity.additionalField}</dd>
          <dt>
            <span id="address">
              <Translate contentKey="rainspotApp.applicationUser.address">Address</Translate>
            </span>
          </dt>
          <dd>{applicationUserEntity.address}</dd>
          <dt>
            <span id="city">
              <Translate contentKey="rainspotApp.applicationUser.city">City</Translate>
            </span>
          </dt>
          <dd>{applicationUserEntity.city}</dd>
          <dt>
            <span id="state">
              <Translate contentKey="rainspotApp.applicationUser.state">State</Translate>
            </span>
          </dt>
          <dd>{applicationUserEntity.state}</dd>
          <dt>
            <span id="zipcode">
              <Translate contentKey="rainspotApp.applicationUser.zipcode">Zipcode</Translate>
            </span>
          </dt>
          <dd>{applicationUserEntity.zipcode}</dd>
          <dt>
            <Translate contentKey="rainspotApp.applicationUser.internalUser">Internal User</Translate>
          </dt>
          <dd>{applicationUserEntity.internalUser ? applicationUserEntity.internalUser.id : ''}</dd>
          <dt>
            <Translate contentKey="rainspotApp.applicationUser.organization">Organization</Translate>
          </dt>
          <dd>{applicationUserEntity.organization ? applicationUserEntity.organization.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/application-user" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/application-user/${applicationUserEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ApplicationUserDetail;
